import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { ApiCallService } from '../services/api-call.service';
import { UtilService } from '@app/shared/services/util.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { MatTooltipModule, MatTooltip } from '@angular/material/tooltip';

@Component({
    imports: [CommonModule, FormsModule, SharedModule, RouterModule, MatTooltipModule],
    selector: 'app-dev-console',
    templateUrl: './dev-console.component.html',
    styleUrls: ['./dev-console.component.css']
})
export class DevConsoleComponent implements OnInit {
  keys: any = [];
  loading = false;
  copiedKeyId: string | null = null;
  lastTooltip: MatTooltip | null = null;
  

  constructor(
    private apiKeyService: ApiCallService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private util: UtilService,
    private logger: LoggerService
  ) {}

  ngOnInit() {
    this.fetchKeys();
  }

  fetchKeys() {
    this.loading = true;
    this.apiKeyService.getAllKeys().subscribe(
       (data: any) => {
         const response = data['body']['responseBody'];
         if (response) {
          this.keys = response;
          this.loading = false; // Hide loading state
          this.cdr.detectChanges();
         } else {
          this.keys = [];
          this.loading = false; // Hide loading state
          this.cdr.detectChanges();
         }
       },
       (error) => {
         this.loading = false; // Hide loading state
         this.cdr.detectChanges();
         console.error('Error fetching revision history:', error);
       }
     );
  }

  goToGenerateKey() {
    this.router.navigate(['/generate-key']);
  }

  toggleActive(event: Event, key: any) {
    event.preventDefault();
    const postData = {
      id: key.id,
      is_active: !key.is_active,
    }
    this.apiKeyService.updateKeyStatus(postData).subscribe(
      (data: any) => {
        const response = data['body']['responseBody'];
        if (response) {

          this.util.simpleDialog({
            title: 'success',
            message: "Status updated successfully",
          });
          key.is_active = !key.is_active;
          this.cdr.detectChanges();
        } else {
          this.util.simpleDialog({ 
            title : 'error',
            message :"Status update failed"
          });
          this.cdr.detectChanges();
        }
      },
      (error) => {
        console.error('Error creating API Key:', error);
        this.logger.error('Error creating API Key:', error);
        this.util.simpleDialog({
          title: 'error',
          message: error
        });
        this.cdr.detectChanges();
      }
    );
  }


  copyKey(apiKey: string, tooltip: MatTooltip): void {
    navigator.clipboard.writeText(apiKey).then(() => {
      // Hide previous tooltip if any
      if (this.lastTooltip && this.lastTooltip !== tooltip) {
        this.lastTooltip.hide();
      }

      // Set current
      this.copiedKeyId = apiKey;
      this.lastTooltip = tooltip;

      // Show new tooltip
      tooltip.show();
    });
  }


  viewLogs(key: any) {
    this.router.navigate(['/dev-console/logs'], { queryParams: { keyId: key.id } });
  }

}
